import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { Button, Stack } from '@mui/material';

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <Stack direction="row" alignItems="center" sx={{ mb: 4, mt: 1 }}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ textTransform: 'none', fontSize: '16px',ml: 1 }}
      >
        Back
      </Button>
    </Stack>
  );
};

export default BackButton;
